import { Component } from "react";

class ProductSpecs extends Component {
  render() {
    const title = this.props.title || "XLP Learning Advance Kit";
    const subtitle =
      this.props.subtitle ||
      "Automation & Robotics Learning Kit for Kids (10+ Years)";

    // Expecting an array of strings for the description paragraphs
    const descriptionParagraphs = this.props.descriptionParagraphs || [
      "The XLP Learning Advance Kit is a hands-on automation and robotics learning kit designed for kids aged 10 years and above. This kit introduces young learners to the fundamentals of robotics, electronics, and mechanical systems through practical experimentation and model building.",
      "Students can explore how different components such as motors, connectors, and mechanical parts work together to create automated systems. The kit encourages creative problem-solving, critical thinking, and engineering skills, making it an ideal tool for STEM education.",
      "Whether used at home, in classrooms, or during robotics workshops, the XLP Learning Advance Kit helps children move beyond theory and learn by building, experimenting, and discovering real-world technology concepts.",
    ];

    const manufacturedBy = this.props.manufacturedBy || "XLP Production";
    const quantity = this.props.quantity || "1 Complete Robotics Learning Kit";

    // Expecting an array of strings for the contents list
    const contentsList = this.props.contentsList || [
      "Robotics construction components",
      "Motors and connectors",
      "Mechanical parts for model building",
      "Base structure elements",
      "Assembly accessories",
      "Learning guide / instruction support",
    ];

    const materialType =
      this.props.materialType ||
      "High-quality durable plastic and electronic components designed for repeated learning and safe handling by students.";
    const recommendedAge =
      this.props.recommendedAge || "Kids 10 Years and Above";

    const headingStyle = {
      color: "#b54a2e",
      fontSize: "18px",
      fontWeight: "500",
    };

    return (
      <section className="py-5 bg-light">
        <div className="container py-3">
          {/* Main Title & Subtitle */}
          <div className="mb-5">
            <h1 className="fw-bold mb-2" style={{ color: "#b54a2e" }}>
              {title}
            </h1>
            <p
              className="text-dark fw-normal mb-0"
              style={{ fontSize: "15px" }}
            >
              {subtitle}
            </p>
          </div>

          {/* Specifications Grid Layout */}
          <div className="row g-5">
            {/* LEFT COLUMN: Main Descriptions */}
            <div className="col-12 col-lg-7 pe-lg-4">
              {/* Product Description */}
              <div className="mb-4">
                <h4 className="mb-3" style={headingStyle}>
                  Product Description
                </h4>
                <div
                  className="text-secondary"
                  style={{ fontSize: "15px", lineHeight: "1.7" }}
                >
                  {descriptionParagraphs.map((para, index) => (
                    <p key={index} className="mb-3">
                      {/* Using simple bolding logic for keywords if needed, or rendering plain */}
                      {para}
                    </p>
                  ))}
                </div>
              </div>

              {/* Manufactured By */}
              <div className="mt-4 pt-2">
                <h4 className="mb-2" style={headingStyle}>
                  Manufactured By
                </h4>
                <p className="text-dark mb-0" style={{ fontSize: "15px" }}>
                  {manufacturedBy}
                </p>
              </div>
            </div>

            {/* RIGHT COLUMN: Quick Specs & Contents */}
            <div className="col-12 col-lg-5">
              <div className="d-flex flex-column gap-4">
                {/* Quantity */}
                <div>
                  <h4 className="mb-2" style={headingStyle}>
                    Quantity
                  </h4>
                  <p className="text-dark mb-0" style={{ fontSize: "15px" }}>
                    {quantity}
                  </p>
                </div>

                {/* Contents in the Box */}
                <div>
                  <h4 className="mb-2" style={headingStyle}>
                    Contents in the Box
                  </h4>
                  <ul
                    className="text-dark mb-0 ps-3"
                    style={{ fontSize: "15px", lineHeight: "1.8" }}
                  >
                    {contentsList.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>

                {/* Material Type */}
                <div>
                  <h4 className="mb-2" style={headingStyle}>
                    Material Type
                  </h4>
                  <p
                    className="text-dark mb-0"
                    style={{ fontSize: "15px", lineHeight: "1.6" }}
                  >
                    {materialType}
                  </p>
                </div>

                {/* Recommended Age */}
                <div>
                  <h4 className="mb-2" style={headingStyle}>
                    Recommended Age
                  </h4>
                  <p className="text-dark mb-0" style={{ fontSize: "15px" }}>
                    {recommendedAge}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default ProductSpecs;

//USE IT LIKE THIS IN A NEW SCREEN BUT I BET THERE IS A BETTER WAY TO THIS BUT WHAT THE HELL

{
  /* <ProductSpecs 
  title="XLP Student Basic Kit"
  subtitle="Entry-Level STEM Kit for Beginners (8+ Years)"
  quantity="1 Basic Starter Kit"
  recommendedAge="Kids 8 Years and Above"
  contentsList={[
    "Core construction blocks",
    "Simple DC motor",
    "Battery holder and base plate",
    "Beginner manual"
  ]}
  descriptionParagraphs={[
    "The perfect introductory kit for students taking their first steps into the world of electronics and mechanics.",
    "Designed for absolute beginners with simple snap-together parts."
  ]}
/> */
}
